export default __webpack_public_path__ + "static/stickers-cuadrados-caja-herramientas-07c394fd968b70465c5cd059438311bc.jpg";